import React from 'react';
import Banner from '../Components/Banner';
import BannerImage from "../Images/blog-banner.jpg";
import { Container, Row, Col } from 'react-bootstrap';

import ContactSection from '../Components/ContactSection';
import { Link } from 'react-router-dom';
import BlogData from '../Data/BlogData';

const Blogs = () => {
  const bannerTitle = <>Blogs</>;
  const bannerContent = "";
  const bannerConclude = "";

  return (
    <div className='home-content'>
      <Banner
        image={BannerImage}
        propAlt="Home Banner"
        bannerTitle={bannerTitle}
        bannerContent={bannerContent}
        bannerConclude={bannerConclude}
      />

      <section className='section-pad blogs'>
        <Container>
          {BlogData.map((blog, index) => (
            <Row
              key={blog.id}
              className='d-flex align-items-center justify-content-center mb-5'
            >
              <Col lg={6} xs={12}>
                <img
                  className='img-responsive rounded'
                  src={blog.listImage}
                  alt={`Blog ${index + 1}`}
                />
              </Col>
              <Col lg={6} xs={12}>
                <div className='about-left-content pl-5 pr-5'>
                  <h3 className='title mb-3'>{blog.title}</h3>
                  <p className='text-justify MB-5'>
                    {
                      Array.isArray(blog.content)
                        ? blog.content.find(item => item.type === 'paragraph')?.text
                        : blog.content
                    }...
                  </p>

                  <Link to="/blogs/blog-inner" state={{ blog }} className="btn-style" title="btn">
                    Read More
                  </Link>
                </div>
              </Col>
            </Row>
          ))}
        </Container>
      </section>

      <ContactSection />
    </div>
  );
};

export default Blogs;
